// Guards an <img>/media `src` against bare storage keys. When media-URL signing fails
// server-side, the API can return a raw object key (e.g. "802tlJty...") instead of a signed
// URL. Rendered directly, the browser resolves that relative value against the SPA origin and
// fetches index.html — a broken image. Returns the value only when it is a safely displayable
// absolute URL (http/https/data/blob); otherwise undefined so React omits the src attribute.
export function safeMediaSrc(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  return /^(https?:\/\/|data:|blob:)/i.test(url) ? url : undefined;
}

/** True when a signed media URL can be rendered in an `<img>` (not a direct video file URL). */
export function isRasterMediaSrc(url: string | null | undefined): boolean {
  const src = safeMediaSrc(url);
  if (!src) return false;
  return !/\.(mp4|mov|m4v|webm)(\?|#|$)/i.test(src.split('?')[0] ?? '');
}
